(function () {
  'use strict';

  // Guard: bp-product-assets renders inside each section via `render` (isolated
  // scope), so Liquid deduplication doesn't work across sections — the browser
  // re-executes this script for every <script> tag even from cache. This flag
  // ensures the init logic only runs once per page load.
  if (window._bpProductLoaded) return;
  window._bpProductLoaded = true;

  // ── Money formatter ────────────────────────────────────────────────────────
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  }

  // ── Mobile carousel + dots ─────────────────────────────────────────────────
  function initCarousel() {
    var carousel = document.querySelector('.bph__carousel');
    var dots = Array.from(document.querySelectorAll('.bph__dot'));
    if (!carousel || !dots.length) return;

    function updateDots() {
      var index = Math.round(carousel.scrollLeft / carousel.offsetWidth);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }

    carousel.addEventListener('scroll', updateDots, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        carousel.scrollTo({ left: i * carousel.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  // ── Desktop gallery thumbnails ─────────────────────────────────────────────
  function initThumbs() {
    var mainImg = document.getElementById('bph-main-img');
    var thumbs = Array.from(document.querySelectorAll('.bph__thumb'));
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.src;
        var srcset = thumb.dataset.srcset;
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  // ── Quantity selector ──────────────────────────────────────────────────────
  function initQuantity() {
    var ctrl = document.querySelector('.bph__qty-ctrl');
    if (!ctrl) return;

    var minus = ctrl.querySelector('[data-qty="minus"]');
    var plus = ctrl.querySelector('[data-qty="plus"]');
    var display = ctrl.querySelector('.bph__qty-val');
    var hidden = ctrl.querySelector('input[name="quantity"]');

    if (!minus || !plus || !display) return;

    minus.addEventListener('click', function () {
      var val = parseInt(display.textContent, 10);
      if (val > 1) {
        display.textContent = val - 1;
        if (hidden) hidden.value = val - 1;
      }
    });

    plus.addEventListener('click', function () {
      var val = parseInt(display.textContent, 10);
      display.textContent = val + 1;
      if (hidden) hidden.value = val + 1;
    });
  }

  // ── Variant picker ─────────────────────────────────────────────────────────
  function initVariants() {
    var form = document.querySelector('.bph__form');
    if (!form) return;

    var variantInput = document.getElementById('bph-variant-id');
    var priceEl = document.getElementById('bph-price');
    var compareEl = document.getElementById('bph-compare-price');
    var atcBtn = document.querySelector('.bph__atc');
    var variantDataEl = form.querySelector('[data-variant-json]');

    if (!variantDataEl) return;

    var variants;
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      return;
    }

    var optionGroups = Array.from(form.querySelectorAll('[data-option-index]'));

    function getSelectedOptions() {
      return optionGroups.map(function (group) {
        var active = group.querySelector('.bph__option-btn.is-active');
        return active ? active.dataset.value : null;
      });
    }

    function findVariant(selectedOptions) {
      return variants.find(function (v) {
        return selectedOptions.every(function (val, idx) {
          return val === null || v.options[idx] === val;
        });
      });
    }

    function syncGalleryToVariant(variant) {
      if (!variant || !variant.featured_image) return;
      var imgSrc = variant.featured_image.src;

      // Update desktop main image
      var mainImg = document.getElementById('bph-main-img');
      if (mainImg) mainImg.src = imgSrc;

      // Activate matching thumbnail
      var thumbs = Array.from(document.querySelectorAll('.bph__thumb'));
      thumbs.forEach(function (t) {
        var match = t.dataset.src && t.dataset.src.split('?')[0] === imgSrc.split('?')[0];
        t.classList.toggle('is-active', match);
      });
    }

    function onVariantChange() {
      var selectedOptions = getSelectedOptions();
      var variant = findVariant(selectedOptions);

      // Keep each option label in sync with its active button.
      optionGroups.forEach(function (group, index) {
        var selectedValue = selectedOptions[index];
        var labelValue = group.querySelector('.bph__option-label strong');
        if (labelValue && selectedValue !== null) {
          labelValue.textContent = selectedValue;
        }
      });

      if (variant && variantInput) variantInput.value = variant.id;

      // Price
      if (priceEl && variant) {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (compareEl && variant) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // ATC state
      if (atcBtn) {
        if (!variant) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Unavailable';
        } else if (!variant.available) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Sold Out';
        } else {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        }
      }

      form.dispatchEvent(new CustomEvent('bp:variant-change', {
        bubbles: true,
        detail: { variant: variant || null },
      }));

      syncGalleryToVariant(variant);
    }

    // Attach click handlers
    optionGroups.forEach(function (group) {
      var buttons = Array.from(group.querySelectorAll('.bph__option-btn'));
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          onVariantChange();
        });
      });
    });

    // Init on load
    onVariantChange();
  }

  // ── Bootstrap ──────────────────────────────────────────────────────────────
  // AJAX add-to-cart for the custom BusterPro product form.
  function isInventoryError(data, status) {
    var original = (data && (data.description || data.message)) || '';
    var normalized = original.toLowerCase();
    return status === 422 && (
      !original ||
      /sold out|out of stock|inventory|not enough|only .* available|can(?:not|'t) add more|unable to add item/.test(normalized)
    );
  }

  function getAddToCartError(data, status) {
    var original = (data && (data.description || data.message)) || '';
    return isInventoryError(data, status)
      ? 'Sorry, this item is out of stock or there are no more units available.'
      : original || 'We could not add this item. Please try again.';
  }

  function addCartItem(formData) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          var error = new Error(getAddToCartError(data, response.status));
          error.inventory = isInventoryError(data, response.status);
          throw error;
        }
        return data;
      });
    });
  }

  function getInventoryMap(form) {
    var inventoryEl = form.querySelector('[data-inventory-json]');
    if (!inventoryEl) return {};
    try {
      return JSON.parse(inventoryEl.textContent);
    } catch (error) {
      return {};
    }
  }

  function getAvailableToAdd(inventory, variantId) {
    var info = inventory[String(variantId)];
    if (!info || !info.tracked || info.continueSelling) return Promise.resolve(null);

    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        var alreadyInCart = cart && cart.items
          ? cart.items.reduce(function (total, item) {
              return total + (String(item.variant_id) === String(variantId) ? item.quantity : 0);
            }, 0)
          : 0;
        return Math.max(0, Number(info.quantity || 0) - alreadyInCart);
      })
      .catch(function () { return Math.max(0, Number(info.quantity || 0)); });
  }

  function initAddToCart() {
    var form = document.querySelector('.bph__form');
    if (!form) return;

    var atcBtn = form.querySelector('.bph__atc');
    var inventory = getInventoryMap(form);
    var currentVariantAvailable = atcBtn ? !atcBtn.disabled : true;

    form.addEventListener('bp:variant-change', function (event) {
      var variant = event.detail && event.detail.variant;
      currentVariantAvailable = Boolean(variant && variant.available);
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (atcBtn && atcBtn.disabled) return;

      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';
      }

      var originalData = new FormData(form);
      var variantId = originalData.get('id');
      var requestedQuantity = Math.max(1, parseInt(originalData.get('quantity'), 10) || 1);
      var addedQuantity = requestedQuantity;

      try {
        var available = await getAvailableToAdd(inventory, variantId);
        if (available !== null) addedQuantity = Math.min(requestedQuantity, available);

        if (addedQuantity < 1) {
          document.dispatchEvent(new CustomEvent('bp:cart:open', {
            detail: { notice: 'All available units of this item are already in your cart.' },
          }));
          return;
        }

        var addData = new FormData(form);
        addData.set('quantity', String(addedQuantity));

        try {
          await addCartItem(addData);
        } catch (error) {
          // Inventory may change between rendering and checkout. Retry one unit once.
          if (!error.inventory || addedQuantity === 1) throw error;
          addedQuantity = 1;
          addData.set('quantity', '1');
          await addCartItem(addData);
        }

        var notice = '';
        if (addedQuantity < requestedQuantity) {
          notice = addedQuantity === 1
            ? 'Only 1 unit was available and added to your cart.'
            : 'Only ' + addedQuantity + ' units were available and added to your cart.';
        }

        var quantityInput = form.querySelector('input[name="quantity"]');
        var quantityDisplay = form.querySelector('.bph__qty-val');
        if (quantityInput) quantityInput.value = addedQuantity;
        if (quantityDisplay) quantityDisplay.textContent = addedQuantity;

        document.dispatchEvent(new CustomEvent('bp:cart:refresh'));
        document.dispatchEvent(new CustomEvent('bp:cart:open', {
          detail: notice ? { notice: notice } : null,
        }));
      } catch (error) {
        console.error(error);
        if (error.inventory) {
          currentVariantAvailable = false;
          form.dispatchEvent(new CustomEvent('bp:variant-change', {
            bubbles: true,
            detail: {
              variant: {
                id: Number(variantId),
                available: false,
              },
            },
          }));
        } else if (atcBtn) {
          atcBtn.textContent = error.message || 'Try again';
        }
      } finally {
        if (atcBtn) {
          atcBtn.disabled = !currentVariantAvailable;
          if (!currentVariantAvailable) {
            atcBtn.textContent = 'Sold Out';
          } else if (atcBtn.textContent === 'Adding...') {
            atcBtn.textContent = 'Add to Cart';
          }
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCarousel();
    initThumbs();
    initQuantity();
    initVariants();
    initAddToCart();
  });
})();
